export default __webpack_public_path__ + "static/media/vxrp.d59df99f.png";